// Assuming apiKey is defined and imported from 'apikey.js'
import { apiKey } from './apikey.js';

const headers = {
  'Authorization': `Bearer ${apiKey}`,
  'Content-Type': 'application/json'
};

async function generateContent(role, prompt) {
  const response = await fetch('https://api.openai.com/v1/chat/completions', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      model: 'gpt-3.5-turbo',
      messages: [{
        role: 'system',
        content: role
      }, {
        role: 'user',
        content: prompt
      }]
    })
  });
  const data = await response.json();
  return data.choices[0].message.content;
}

async function generateConcept({ gptRole, bookLength, genre, keywords }) {
  const prompt = `Generate a ${bookLength}-word ${genre} concept with keywords: ${keywords.join(', ')}.`;
  return await generateContent(gptRole, prompt);
}

async function generateTableOfContents({ gptRole, genre, keywords, concept }) {
  const prompt = `Based on the ${genre} concept: "${concept}" with keywords: ${keywords.join(', ')}, generate a table of contents.`;
  return await generateContent(gptRole, prompt);
}

async function generateChapters({ gptRole, genre, keywords, tableOfContents, autoGen }) {
  const chapters = tableOfContents.split('\n').filter(line => line.trim() !== '');
  let chaptersContent = [];
  for (let i = 0; i < chapters.length; i++) {
    const chapterTitle = chapters[i];
    const prompt = `Based on the ${genre} chapter title: "${chapterTitle}" with keywords: ${keywords.join(', ')}, generate the chapter content.`;
    const chapterContent = await generateContent(gptRole, prompt);
    chaptersContent.push({ title: chapterTitle, content: chapterContent });
    if (!autoGen) break; // Stop if auto-generate chapters is not enabled
  }
  return chaptersContent;
}

function exportToTxt(chaptersHtml) {
  // This function could create a blob URL for download or return the content for the caller to handle the download
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(chaptersHtml));
  element.setAttribute('download', 'chapters.txt');
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export { generateConcept, generateTableOfContents, generateChapters, exportToTxt };
